import "@/App.css";
import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Showcase } from "@/components/Showcase";
import { WhyMockTP } from "@/components/WhyMockTP";
import { VideoShowcase } from "@/components/VideoShowcase";
import { Pricing } from "@/components/Pricing";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import About from "@/pages/About";
import Safety from "@/pages/Safety";
import Support from "@/pages/Support";
import AdminEntry from "@/pages/AdminEntry";
import AdminBetaApplications from "@/pages/AdminBetaApplications";
import AdminContactMessages from "@/pages/AdminContactMessages";
import AdminTools from "@/pages/AdminTools";
import { Toaster } from "@/components/ui/sonner";

const Home = () => (
  <div className="grain-overlay bg-[#080C16] min-h-screen text-white">
    <Navigation />
    <Hero />
    <WhyMockTP />
    <VideoShowcase />
    <Showcase />
    <Pricing />
    <FAQ />
    <Contact />
    <Footer />
  </div>
);

const AdminNavigation = () => {
  const { pathname } = useLocation();
  if (!pathname.startsWith("/admin")) return null;

  const linkClass = (active) =>
    `inline-flex h-10 items-center rounded-lg border px-3 text-sm transition-colors ${
      active
        ? "border-[#00DC82]/40 bg-[#00DC82]/10 text-[#9EF5CB]"
        : "border-white/10 text-slate-200 hover:bg-white/5"
    }`;

  return (
    <div className="bg-[#080C16] px-4 pt-4 sm:px-6 lg:px-8">
      <nav className="mx-auto flex max-w-7xl flex-wrap gap-2">
        <Link
          to="/admin/beta-applications"
          className={linkClass(pathname === "/admin/beta-applications")}
        >
          Beta Applications
        </Link>
        <Link
          to="/admin/contact-messages"
          className={linkClass(pathname === "/admin/contact-messages")}
        >
          Contact Messages
        </Link>
        <Link
          to="/admin/tools"
          className={linkClass(pathname === "/admin/tools")}
        >
          Admin Tools
        </Link>
      </nav>
    </div>
  );
};

const AppRoutes = () => (
  <>
    <AdminNavigation />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/about" element={<About />} />
      <Route path="/safety" element={<Safety />} />
      <Route path="/support" element={<Support />} />
      <Route path="/admin" element={<AdminEntry />} />
      <Route path="/admin/beta-applications" element={<AdminBetaApplications />} />
      <Route path="/admin/contact-messages" element={<AdminContactMessages />} />
      <Route path="/admin/tools" element={<AdminTools />} />
    </Routes>
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
